import { FC } from "react";
import { ChipProps } from "./Chip.types";
import classnames from 'classnames';

import styles from './Chip.module.css';

export const Chip: FC<ChipProps> = ({ children, className, ...props }) => {
    return (
        <button className={classnames(styles.chip, className)} {...props}>
            {children}
        </button>
    )
};